
import React from 'react';
import { Route, Switch, withRouter, RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { TabBar } from 'antd-mobile';
import routes from './routes';
// 图片
import HomeImg from './assets/images/tabbar/home.svg';
import HomeImg1 from './assets/images/tabbar/selectHome.svg';
import StudyImg from './assets/images/tabbar/study.svg';
import StudyImg1 from './assets/images/tabbar/selectStudy.svg';
import InteractImg from './assets/images/tabbar/hudong.svg';
import InteractImg1 from './assets/images/tabbar/selectHudong.svg';
import PersonImg from './assets/images/tabbar/person.svg';
import PersonImg1 from './assets/images/tabbar/selectPerson.svg';
import './index.less';

interface IProps extends RouteComponentProps {
  isShowTab: boolean,
};
interface IState {
  selectedTab: string,
  tabbarData: any[]
};

class App extends React.PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      selectedTab: 'home',
      tabbarData: [
        { key: 'home', title: '首页', url: '/', icon: HomeImg, selectedIcon: HomeImg1, badge: null },
        { key: 'study', title: '正在学习', url: '/study', icon: StudyImg, selectedIcon: StudyImg1, badge: 'new' },
        { key: 'interact', title: '互动', url: '/interact', icon: InteractImg, selectedIcon: InteractImg1, badge: 10 },
        { key: 'person', title: '个人', url: '/my', icon: PersonImg, selectedIcon: PersonImg1, badge: null }
      ]
    }
  }
  // 改变tabbar
  changeTab = (item: any) => {
    this.setState({
      selectedTab: item.key
    }, () => {
      this.props.history.push(item.url);
    })
  }

  render() {
    const { selectedTab, tabbarData } = this.state;
    const { isShowTab } = this.props;
    return (
        <div className="app">
          <div className="app_top">
            <Switch>
              {
                routes.map(item => {
                  return <Route exact key={item.path} path={item.path} component={item.component}></Route>
                })
              }
            </Switch>
          </div>
          <div className="app_tabbar">
          <TabBar
            unselectedTintColor="#949494"
            tintColor="#05a870"
            barTintColor="white"
            hidden={isShowTab}
          >
            {
              tabbarData.map(item => {
                return (
                  <TabBar.Item
                    title={item.title}
                    key={item.key}
                    icon={<div style={{
                      width: '22px',
                      height: '22px',
                      background: `url(${item.icon}) center center /  21px 21px no-repeat` }}
                    />
                    }
                    selectedIcon={<div style={{
                      width: '22px',
                      height: '22px',
                      background: `url(${item.selectedIcon}) center center /  21px 21px no-repeat` }}
                    />
                    }
                    selected={selectedTab === item.key}
                    badge={item.badge}
                    onPress={() => {
                      this.changeTab(item);
                    }}
                  >
                  </TabBar.Item>
                )
              })
            }
          </TabBar>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  const { isShowTab } = state.mobile;
  return {
    isShowTab
  }
}

export default withRouter(connect(mapStateToProps)(App));
